import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import loginType from "../../redux/actions/login/loginType";

import Login from "../../components/public/login/login";
import Register from "../../components/public/login/register";
import GetStatusUser from "../../components/public/login/getStatusUser";
import LoginByPassComponent from "../../components/public/login/loginByPassComponent";

export default function Authentication(props) {
  const activeStep = useSelector((state) => state.loginDetail.activeStep);
  const dispatch = useDispatch();
  // clear prevPath
  if (!props.location.state) props.location.state = { prevPath: "/" };
  // Make prev back button work in forgetPassPage
  useEffect(() => {
    if (
      props.location.state &&
      props.location.state.prevPath === "loginByPassComponent"
    ) {
      dispatch({
        type: loginType.CHANGE_ACTIVE_STEP,
        payload: 1,
        username: "",
      });
      props.location.state = undefined;
    } else {
      // Go to first step on overy authentication page-call
      dispatch({
        type: loginType.CHANGE_ACTIVE_STEP,
        payload: 0,
        username: "",
      });
    }
  }, []);

  switch (activeStep) {
    case 0:
      return <GetStatusUser />;

    case 1:
      return <LoginByPassComponent props={props} />;

    case 2:
      return <Login props={props} />;

    case 3:
      return <Register props={props} />;

    default:
      return <GetStatusUser />;
  }
}
